// extracted by mini-css-extract-plugin
module.exports = {"fit-image":"ProductMenu_fit-image_3WjUB"};